import * as _ from "lodash";
import { createSelector } from "reselect";
import { ActiveListingsStatus } from "office/reports/activeListings/ActiveListingsReport";
import { ListingType } from "common/types/CommonDto";
import EnumHelper from "common/utils/EnumHelper";
//-- Selector
// Mapping for each report item
const mapItems = (items) => {
    let temp = [];
    if (items) {
        temp = items;
        temp.forEach((item) => {
            item.listingType = EnumHelper.GetDescription(ListingType, item.listingType);
            item.status = item.status.map((it) => EnumHelper.GetDescription(ActiveListingsStatus, it));
        });
    }
    return temp;
};
// Active listings
const stateReportSelector = (state) => state.reports.officeReports.activeListings;
// Transformed Active listings
export const reportSelector = createSelector(stateReportSelector, (report) => {
    if (!report) {
        return {
            isFetching: true,
            reportData: null
        };
    }
    let reportClone = _.cloneDeep(report);
    return {
        isFetching: reportClone.isFetching,
        reportData: {
            officeId: reportClone.officeId,
            officeName: reportClone.officeName,
            date: reportClone.date,
            items: mapItems(reportClone.items)
        }
    };
});
export default reportSelector;
